import * as type from './actionTypesSagas';

export const loadPracticeExamInformation = (
  rate,
  rank,
  dutyState,
  practiceExamId,
) => ({
  type: type.LOAD_PRACTICE_EXAM_INFORMATION,
  rate,
  rank,
  dutyState,
  practiceExamId,
});

export const createPracticeExam = (examId) => ({
  type: type.CREATE_PRACTICE_EXAM,
  examId,
});

export const buildPracticeExam = (practiceExamId) => ({
  type: type.BUILD_PRACTICE_EXAM,
  practiceExamId,
});

export const checkBuildPEProgress = () => ({
  type: type.CHECK_BUILD_PE_PROGRESS,
});

export const removeQuestion = (practiceExamId, questionId) => ({
  type: type.REMOVE_QUESTION,
  practiceExamId,
  questionId,
});

export const activateExam = (practiceExamId) => ({
  type: type.ACTIVATE_EXAM,
  practiceExamId,
});

export const buildAllExams = (payload) => ({
  type: type.BUILD_ALL_EXAMS,
  payload,
});
